import {
  IngredientListItemButton,
  IngredientListItemContainer,
  IngredientListItemContentContainer,
  IngredientListItemIcon,
  IngredientListItemImage,
  IngredientListItemNoticeLabel,
  IngredientListItemPressable,
  IngredientListItemQuantityStepper,
  IngredientListItemTitle,
} from './components';

export const IngredientListItem = {
  Pressable: IngredientListItemPressable,
  Container: IngredientListItemContainer,
  ContentContainer: IngredientListItemContentContainer,
  Icon: IngredientListItemIcon,
  Image: IngredientListItemImage,
  Title: IngredientListItemTitle,
  Button: IngredientListItemButton,
  NoticeLabel: IngredientListItemNoticeLabel,
  QuantityStepper: IngredientListItemQuantityStepper,
};
